import axiosInstance from "./AxiosInstance";

export function removeFvourite(candidate_ids) {
  const data = { candidate_ids };
  return axiosInstance.post("recruiter/candidates/favorite/remove", data);
}
